exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".my-drop-zone {\n  position: relative; }\n  .my-drop-zone .drop-legend {\n    display: block; }\n  .my-drop-zone .drop-here {\n    display: none; }\n  .my-drop-zone input[type=file] {\n    cursor: pointer;\n    height: 100%;\n    left: 0;\n    opacity: 0;\n    position: absolute;\n    top: 0;\n    width: 100%;\n    z-index: 99; }\n  .my-drop-zone.nv-file-over {\n    background-color: #f3f3f3;\n    border: 1px dashed #a3a3a3; }\n    .my-drop-zone.nv-file-over .drop-legend {\n      display: none; }\n    .my-drop-zone.nv-file-over .drop-here {\n      display: block; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/ing-dynamic-form/dynamic-form/ing-upload/ing-upload.component.scss
// module id = 1132
// module chunks = 13